module.exports = __webpack_public_path__ + "img/spinner-green-32.a5a365c6.gif";